/**
 * @fileoverview ESM bridge for `./error-ids.js` import specifiers.
 *
 * @purpose Next.js webpack resolves the `.js` path literally; the registry and helpers live in
 *   the sibling `error-ids.ts`. Node/tsx loads this file, then resolves the TypeScript module.
 * @ownership @korvo/core
 * @dependencies `./error-ids.ts`
 */
export * from './error-ids.ts';
